import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';
import { SelectPaymentModal } from './select-payment-modal';
import { SelectCreditCardComponent } from 'src/app/components/select-credit-card/select-credit-card.component';
import { SelectCryptoCardComponent } from 'src/app/components/select-crypto-card/select-crypto-card.component';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    SafeHtmlsModule,
  ],
  declarations: [SelectCryptoCardComponent, SelectPaymentModal, SelectCreditCardComponent],
})
export class SelectPaymentModule { }
